import type { FC } from 'react';
import { lazy, Suspense } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';

const LoadablePresetsModalPopup = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "presetspopup" */
        './PresetsModal'
      )
  )
);

interface Props {
  requestClose: () => void;
}

const LazyPresetsModalPopup: FC<Props> = props => (
  <ErrorBoundary debugComponent="LazyPresetsModalPopup">
    <Suspense fallback={<LoadingIndicator view={'llama'} withOverlay usePortal />}>
      <LoadablePresetsModalPopup {...props} />
    </Suspense>
  </ErrorBoundary>
);
LazyPresetsModalPopup.displayName = 'LazyPresetsModalPopup';

export default LazyPresetsModalPopup;
